const translations = {
  // Navbar
  nav: {
    home: { en: "Home", gr: "Αρχική" },
    about: { en: "About", gr: "Σχετικά" },
    services: { en: "Services", gr: "Υπηρεσίες" },
    portfolio: { en: "Portfolio", gr: "Έργα" },
    contact: { en: "Contact", gr: "Επικοινωνία" },
    creators: { en: "For Creators", gr: "Για Δημιουργούς" },
  },

  // Home - Hero
  home: {
    badge: { en: "Web Development & Digital Solutions", gr: "Ανάπτυξη Web & Ψηφιακές Λύσεις" },
    tagline: {
      en: "We Build Your Digital Presence",
      gr: "Χτίζουμε την Ψηφιακή σας Παρουσία",
    },
    sub: {
      en: "Websites, e-shops, and digital marketing solutions for every business — from freelancers and shops to restaurants and growing companies. Personal support, real results.",
      gr: "Websites, e-shops και λύσεις digital marketing για κάθε επιχείρηση — από ελεύθερους επαγγελματίες και καταστήματα μέχρι εστιατόρια και αναπτυσσόμενες εταιρείες. Προσωπική υποστήριξη, πραγματικά αποτελέσματα.",
    },
    ctaServices: { en: "See Our Plans", gr: "Δείτε τα Πακέτα μας" },
    ctaContact: { en: "Get In Touch", gr: "Επικοινωνήστε μαζί μας" },

    // Who We Are
    whoWeAre: { en: "Who We Are", gr: "Ποιοι Είμαστε" },
    introP1: {
      en: "MyApple is a web development and digital solutions agency based in Greece. We help businesses of all sizes establish and grow their online presence — with",
      gr: "Η MyApple είναι μια εταιρεία ανάπτυξης web και ψηφιακών λύσεων με έδρα την Ελλάδα. Βοηθάμε επιχειρήσεις κάθε μεγέθους να δημιουργήσουν και να αναπτύξουν τη διαδικτυακή τους παρουσία — με",
    },
    introLogistics: { en: "professional websites", gr: "επαγγελματικά websites" },
    introData: { en: "online stores", gr: "online καταστήματα" },
    introWeb: { en: "digital marketing", gr: "digital marketing" },
    introP2: {
      en: "With over a decade of experience in web development, e-commerce, and digital strategy, we've built solutions for shops, restaurants, professionals, creators, and companies across Greece. We don't just deliver a website — we become your technology partner.",
      gr: "Με πάνω από μια δεκαετία εμπειρίας σε web development, e-commerce και ψηφιακή στρατηγική, έχουμε δημιουργήσει λύσεις για καταστήματα, εστιατόρια, επαγγελματίες, δημιουργούς και εταιρείες σε όλη την Ελλάδα. Δεν παραδίδουμε απλά ένα website — γινόμαστε ο τεχνολογικός σας συνεργάτης.",
    },
    introMission: { en: "Our mission:", gr: "Η αποστολή μας:" },
    introMissionBold: {
      en: "bring every business online",
      gr: "να φέρουμε κάθε επιχείρηση online",
    },
    introMissionEnd: {
      en: "with solutions that actually work — simple, effective, and personally supported.",
      gr: "με λύσεις που πραγματικά δουλεύουν — απλές, αποτελεσματικές και με προσωπική υποστήριξη.",
    },
    learnMore: { en: "Learn more about us →", gr: "Μάθετε περισσότερα →" },

    // Stats
    statYears: { en: "Years of Experience", gr: "Χρόνια Εμπειρίας" },
    statProjects: { en: "Projects Delivered", gr: "Ολοκληρωμένα Έργα" },
    statAreas: { en: "Core Service Areas", gr: "Βασικοί Τομείς" },
    statClient: { en: "Client-Focused", gr: "Εστίαση στον Πελάτη" },

    // Services section
    whatWeOffer: { en: "What We Offer", gr: "Τι Προσφέρουμε" },
    servicesSubtitle: {
      en: "Three plans designed to take your business online — no matter your size or industry",
      gr: "Τρία πακέτα σχεδιασμένα να φέρουν την επιχείρησή σας online — ανεξάρτητα από μέγεθος ή κλάδο",
    },
    serviceLearnMore: { en: "Learn more →", gr: "Περισσότερα →" },

    // Service cards
    svcLogisticsTitle: { en: "Professional Website", gr: "Επαγγελματικό Website" },
    svcLogisticsDesc: {
      en: "A clean, modern website to showcase your business, services, or portfolio. Includes hosting, business email, and mobile-friendly design.",
      gr: "Ένα καθαρό, μοντέρνο website για να παρουσιάσετε την επιχείρησή σας, τις υπηρεσίες ή το portfolio σας. Περιλαμβάνει hosting, εταιρικό email και responsive σχεδιασμό.",
    },
    svcDataTitle: { en: "Online Store", gr: "Online Κατάστημα" },
    svcDataDesc: {
      en: "A fully-featured e-shop with inventory management, secure payments, and courier integration. Your store is always open — sell 24/7.",
      gr: "Ένα πλήρες e-shop με διαχείριση αποθέματος, ασφαλείς πληρωμές και σύνδεση courier. Το κατάστημά σας είναι πάντα ανοιχτό — πωλήσεις 24/7.",
    },
    svcWebTitle: { en: "Growth & Marketing", gr: "Ανάπτυξη & Marketing" },
    svcWebDesc: {
      en: "E-shop plus targeted advertising, SEO strategy, social media management, and monthly support. We don't just build — we bring customers to you.",
      gr: "E-shop συν στοχευμένη διαφήμιση, στρατηγική SEO, διαχείριση social media και μηνιαία υποστήριξη. Δεν χτίζουμε μόνο — φέρνουμε πελάτες σε εσάς.",
    },

    // How We Work
    howWeWork: { en: "How We Work", gr: "Πώς Δουλεύουμε" },
    processSubtitle: {
      en: "Simple, personal, step by step",
      gr: "Απλά, προσωπικά, βήμα-βήμα",
    },
    processDiscoveryTitle: { en: "We Meet", gr: "Συναντιόμαστε" },
    processDiscoveryDesc: {
      en: "We sit down together — in person or online — to understand your business, your goals, and what you need.",
      gr: "Καθόμαστε μαζί — δια ζώσης ή online — για να κατανοήσουμε την επιχείρησή σας, τους στόχους σας και τι χρειάζεστε.",
    },
    processAnalysisTitle: { en: "We Plan", gr: "Σχεδιάζουμε" },
    processAnalysisDesc: {
      en: "We design the right solution for you — the structure, the look, the features — and make sure you're happy before we start building.",
      gr: "Σχεδιάζουμε τη σωστή λύση για εσάς — τη δομή, την εμφάνιση, τα χαρακτηριστικά — και βεβαιωνόμαστε ότι σας αρέσει πριν ξεκινήσουμε.",
    },
    processSolutionTitle: { en: "We Build", gr: "Χτίζουμε" },
    processSolutionDesc: {
      en: "We develop your website or e-shop, set up everything, and keep you in the loop throughout the process.",
      gr: "Αναπτύσσουμε το website ή e-shop σας, ρυθμίζουμε τα πάντα και σας κρατάμε ενήμερους σε όλη τη διαδικασία.",
    },
    processResultsTitle: { en: "You Grow", gr: "Αναπτύσσεστε" },
    processResultsDesc: {
      en: "Your business goes live online. We stay by your side for support, updates, and whatever comes next.",
      gr: "Η επιχείρησή σας βγαίνει online. Παραμένουμε δίπλα σας για υποστήριξη, ενημερώσεις και ό,τι ακολουθήσει.",
    },

    // Featured Work
    featuredWork: { en: "Featured Work", gr: "Επιλεγμένα Έργα" },
    featuredSubtitle: {
      en: "Real projects we've built for real businesses",
      gr: "Πραγματικά έργα που χτίσαμε για πραγματικές επιχειρήσεις",
    },
    viewProject: { en: "View Project →", gr: "Δείτε το Έργο →" },
    viewAll: { en: "View All Projects →", gr: "Δείτε Όλα τα Έργα →" },

    // Tech
    techTitle: { en: "Technologies We Use", gr: "Τεχνολογίες που Χρησιμοποιούμε" },

    // Final CTA
    ctaTitle: { en: "Ready to Take Your Business Online?", gr: "Έτοιμοι να Πάτε Online;" },
    ctaDesc: {
      en: "No matter your industry — shop, restaurant, studio, or anything else — we'll build the right digital solution for you. Let's talk.",
      gr: "Ανεξάρτητα από τον κλάδο σας — κατάστημα, εστιατόριο, studio ή οτιδήποτε άλλο — θα χτίσουμε τη σωστή ψηφιακή λύση για εσάς. Ας μιλήσουμε.",
    },
    ctaStart: { en: "Start a Conversation", gr: "Ξεκινήστε μια Συζήτηση" },
    ctaSeeAll: { en: "See All Plans", gr: "Δείτε Όλα τα Πακέτα" },

    // Artisan banner on home
    artisanBadge: { en: "For Handmade Creators", gr: "Για Χειροτέχνες" },
    artisanTitle: { en: "Are You a Handmade Creator?", gr: "Είστε Χειροτέχνης;" },
    artisanDesc: {
      en: "We've built special packages for artisans and creators of the By Hand Festival. From a simple digital showcase to a full e-shop with advertising — with personal, human support at every step.",
      gr: "Δημιουργήσαμε ειδικά πακέτα για χειροτέχνες και δημιουργούς του By Hand Festival. Από μια απλή ψηφιακή βιτρίνα μέχρι πλήρες e-shop με διαφήμιση — με προσωπική, ανθρώπινη υποστήριξη σε κάθε βήμα.",
    },
    artisanCta: { en: "Discover the Plans →", gr: "Ανακαλύψτε τα Πακέτα →" },
  },

  // About page
  about: {
    title: { en: "About MyApple", gr: "Σχετικά με τη MyApple" },
    subtitle: {
      en: "We help businesses of every size go digital — with websites, e-shops, and marketing that actually work.",
      gr: "Βοηθάμε επιχειρήσεις κάθε μεγέθους να μπουν στο digital — με websites, e-shops και marketing που πραγματικά δουλεύουν.",
    },
    storyTitle: { en: "Our Story", gr: "Η Ιστορία μας" },
    storyP1: {
      en: "MyApple is a web development and digital solutions agency based in Greece. For over 10 years, we've been helping businesses — from small shops and freelancers to restaurants and growing companies — build their online presence and reach new customers.",
      gr: "Η MyApple είναι μια εταιρεία ανάπτυξης web και ψηφιακών λύσεων με έδρα την Ελλάδα. Για πάνω από 10 χρόνια, βοηθάμε επιχειρήσεις — από μικρά καταστήματα και ελεύθερους επαγγελματίες μέχρι εστιατόρια και αναπτυσσόμενες εταιρείες — να χτίσουν τη διαδικτυακή τους παρουσία και να βρουν νέους πελάτες.",
    },
    storyP2: {
      en: "With deep experience in web development, e-commerce platforms, and digital marketing, we've delivered solutions for businesses across retail, hospitality, health, sports, and more. Every project is personal — we treat your business like our own.",
      gr: "Με βαθιά εμπειρία σε web development, πλατφόρμες e-commerce και digital marketing, έχουμε παραδώσει λύσεις σε επιχειρήσεις στη λιανική, φιλοξενία, υγεία, αθλητισμό και πολλά άλλα. Κάθε έργο είναι προσωπικό — αντιμετωπίζουμε την επιχείρησή σας σαν δική μας.",
    },
    storyP3: {
      en: "We use modern technologies like React, Node.js, WordPress, and WooCommerce to build fast, reliable, and beautiful digital experiences — always tailored to what each business actually needs.",
      gr: "Χρησιμοποιούμε σύγχρονες τεχνολογίες όπως React, Node.js, WordPress και WooCommerce για να χτίζουμε γρήγορες, αξιόπιστες και όμορφες ψηφιακές εμπειρίες — πάντα προσαρμοσμένες σε αυτό που κάθε επιχείρηση πραγματικά χρειάζεται.",
    },
    whatSetsTitle: { en: "What Sets Us Apart", gr: "Τι μας Ξεχωρίζει" },
    whatSetsP1: {
      en: "We're not a faceless agency. When you work with MyApple, you work directly with the founder. We meet in person or online, we listen to what you need, and we build something that fits — not a template, but a real solution designed for your business.",
      gr: "Δεν είμαστε ένα απρόσωπο γραφείο. Όταν συνεργάζεστε με τη MyApple, συνεργάζεστε απευθείας με τον ιδρυτή. Συναντιόμαστε δια ζώσης ή online, ακούμε τι χρειάζεστε και χτίζουμε κάτι που ταιριάζει — όχι ένα template, αλλά μια πραγματική λύση σχεδιασμένη για την επιχείρησή σας.",
    },
    whatSetsP2: {
      en: "From a simple one-page website to a full e-shop with payments, inventory, and advertising — we handle everything so you can focus on what you do best: running your business.",
      gr: "Από ένα απλό one-page website μέχρι ένα πλήρες e-shop με πληρωμές, απόθεμα και διαφήμιση — αναλαμβάνουμε τα πάντα ώστε εσείς να εστιάσετε σε αυτό που κάνετε καλύτερα: να τρέχετε την επιχείρησή σας.",
    },
    valuesTitle: { en: "Our Values", gr: "Οι Αξίες μας" },
    value1Title: { en: "Results-Driven", gr: "Προσανατολισμός στα Αποτελέσματα" },
    value1Desc: {
      en: "Every recommendation and every line of code is aimed at measurable business outcomes — lower costs, higher efficiency, better decisions.",
      gr: "Κάθε σύσταση και κάθε γραμμή κώδικα στοχεύει σε μετρήσιμα επιχειρηματικά αποτελέσματα — χαμηλότερα κόστη, υψηλότερη αποδοτικότητα, καλύτερες αποφάσεις.",
    },
    value2Title: { en: "Tailored Solutions", gr: "Εξατομικευμένες Λύσεις" },
    value2Desc: {
      en: "No cookie-cutter approaches. We build strategies and tools that fit your specific operations, team, and goals.",
      gr: "Χωρίς τυποποιημένες προσεγγίσεις. Δημιουργούμε στρατηγικές και εργαλεία που ταιριάζουν στις συγκεκριμένες λειτουργίες, την ομάδα και τους στόχους σας.",
    },
    value3Title: { en: "Hands-On Experience", gr: "Πρακτική Εμπειρία" },
    value3Desc: {
      en: "Over a decade of building real solutions for real businesses — we understand the challenges you face because we've been solving them for years.",
      gr: "Πάνω από μια δεκαετία χτίζοντας πραγματικές λύσεις για πραγματικές επιχειρήσεις — κατανοούμε τις προκλήσεις που αντιμετωπίζετε γιατί τις λύνουμε εδώ και χρόνια.",
    },
    value4Title: { en: "End-to-End Support", gr: "Ολοκληρωμένη Υποστήριξη" },
    value4Desc: {
      en: "From the first discovery call through implementation and beyond, we stay involved to make sure the solution keeps delivering value.",
      gr: "Από την πρώτη κλήση ανακάλυψης μέχρι την υλοποίηση και μετά, παραμένουμε ενεργοί για να διασφαλίσουμε ότι η λύση συνεχίζει να προσφέρει αξία.",
    },
    missionTitle: { en: "Our Mission", gr: "Η Αποστολή μας" },
    missionText: {
      en: "with solutions that are simple, effective, and personally supported — no matter the industry or size.",
      gr: "με λύσεις που είναι απλές, αποτελεσματικές και με προσωπική υποστήριξη — ανεξαρτήτως κλάδου ή μεγέθους.",
    },
    missionBold: {
      en: "Bring every business online",
      gr: "Να φέρουμε κάθε επιχείρηση online",
    },
    ctaTitle: { en: "Ready to go digital?", gr: "Έτοιμοι να μπείτε online;" },
    ctaDesc: {
      en: "Let's sit down and plan the right solution for your business — whether it's a website, an e-shop, or a full digital strategy.",
      gr: "Ας καθίσουμε να σχεδιάσουμε τη σωστή λύση για την επιχείρησή σας — είτε πρόκειται για website, e-shop ή πλήρη ψηφιακή στρατηγική.",
    },
    ctaButton: { en: "Contact Us →", gr: "Επικοινωνήστε μαζί μας →" },
  },

  // Services page
  services: {
    title: { en: "Our Services", gr: "Οι Υπηρεσίες μας" },
    subtitle: {
      en: "Whether you're a freelancer, a shop owner, a restaurant, or a growing business — we have a plan that fits your needs. Pick your starting point and let's build from there.",
      gr: "Είτε είστε ελεύθερος επαγγελματίας, κατάστημα, εστιατόριο ή αναπτυσσόμενη επιχείρηση — έχουμε ένα πακέτο που ταιριάζει στις ανάγκες σας. Επιλέξτε το σημείο εκκίνησης και ας χτίσουμε μαζί.",
    },

    // Bronze
    bronzeName: { en: "Bronze", gr: "Bronze" },
    bronzeTitle: { en: "Your Online Presence", gr: "Η Online Παρουσία σας" },
    bronzeTarget: { en: "Ideal for freelancers, professionals & new businesses.", gr: "Ιδανικό για ελεύθερους επαγγελματίες & νέες επιχειρήσεις." },
    bronzeDesc: {
      en: "A professional website that puts your business on the map. Perfect for service providers, consultants, restaurants, studios, and anyone who needs to be found online.",
      gr: "Ένα επαγγελματικό website που βάζει την επιχείρησή σας στον χάρτη. Ιδανικό για παρόχους υπηρεσιών, συμβούλους, εστιατόρια, studios και όποιον θέλει να τον βρίσκουν online.",
    },
    bronzeCta: { en: "Get started", gr: "Ας ξεκινήσουμε" },
    bronzeFeatures: {
      en: ["Professional Hosting", "1-Page Website", "Business Email", "Social Media Integration"],
      gr: ["Επαγγελματικό Hosting", "1-Page Website", "Εταιρικό Email", "Σύνδεση με Social Media"],
    },

    // Silver
    silverName: { en: "Silver", gr: "Silver" },
    silverTitle: { en: "Your Online Store", gr: "Το Online Κατάστημά σας" },
    silverTarget: { en: "For shops & businesses ready to sell online 24/7.", gr: "Για καταστήματα & επιχειρήσεις που θέλουν πωλήσεις 24/7." },
    silverDesc: {
      en: "A fully-featured e-shop with inventory management, secure payments, and courier integration. Whether you sell products, food, or services — your store is always open.",
      gr: "Ένα πλήρες e-shop με διαχείριση αποθέματος, ασφαλείς πληρωμές και σύνδεση courier. Είτε πουλάτε προϊόντα, φαγητό ή υπηρεσίες — το κατάστημά σας είναι πάντα ανοιχτό.",
    },
    silverBadge: { en: "Most Popular", gr: "Δημοφιλέστερο" },
    silverCta: { en: "I want an E-shop", gr: "Θέλω E-shop" },
    silverFeatures: {
      en: ["Full E-shop", "Inventory Management", "Card & PayPal Payments", "Courier Integration"],
      gr: ["Πλήρες E-shop", "Διαχείριση Αποθέματος", "Πληρωμές με Κάρτα/PayPal", "Διασύνδεση με Courier"],
    },

    // Gold
    goldName: { en: "Gold", gr: "Gold" },
    goldTitle: { en: "The Complete Package", gr: "Το Ολοκληρωμένο Πακέτο" },
    goldTarget: { en: "For businesses aiming for maximum growth.", gr: "Για επιχειρήσεις που στοχεύουν σε μέγιστη ανάπτυξη." },
    goldDesc: {
      en: "Everything in Silver plus digital marketing, targeted advertising, SEO strategy, and ongoing monthly support. We don't just build your store — we bring customers to it.",
      gr: "Όλα τα παραπάνω συν digital marketing, στοχευμένη διαφήμιση, στρατηγική SEO και μηνιαία υποστήριξη. Δεν χτίζουμε μόνο το κατάστημά σας — φέρνουμε πελάτες σε αυτό.",
    },
    goldCta: { en: "I want the full package", gr: "Θέλω το πλήρες πακέτο" },
    goldFeatures: {
      en: ["E-shop + Digital Marketing", "Google & Social Ads", "SEO Strategy", "Monthly Support"],
      gr: ["E-shop + Digital Marketing", "Google & Social Ads", "SEO Strategy", "Μηνιαία Υποστήριξη"],
    },

    // Comparison table features
    feat1: { en: "Professional Hosting", gr: "Επαγγελματικό Hosting" },
    feat2: { en: "Business Email", gr: "Εταιρικό Email" },
    feat3: { en: "Custom Domain (yourname.gr)", gr: "Custom Domain (ονομασας.gr)" },
    feat4: { en: "Professional Website", gr: "Επαγγελματικό Website" },
    feat5: { en: "Mobile-Friendly Design", gr: "Responsive Σχεδιασμός" },
    feat6: { en: "Social Media Integration", gr: "Σύνδεση με Social Media" },
    feat7: { en: "Full E-shop", gr: "Πλήρες E-shop" },
    feat8: { en: "Inventory Management", gr: "Διαχείριση Αποθέματος" },
    feat9: { en: "Card & PayPal Payments", gr: "Πληρωμές Κάρτα/PayPal" },
    feat10: { en: "Courier Integration", gr: "Διασύνδεση με Courier" },
    feat11: { en: "Google & Social Ads", gr: "Google & Social Ads" },
    feat12: { en: "SEO Strategy", gr: "Στρατηγική SEO" },
    feat13: { en: "Monthly Support", gr: "Μηνιαία Υποστήριξη" },
    feat14: { en: "Analytics & Reports", gr: "Analytics & Αναφορές" },
    tableHeader: { en: "What you get", gr: "Τι περιλαμβάνει" },

    // Who is it for section
    whoTitle: { en: "Who is this for?", gr: "Σε ποιους απευθυνόμαστε;" },
    whoSubtitle: {
      en: "Our plans are designed for every kind of business and professional.",
      gr: "Τα πακέτα μας είναι σχεδιασμένα για κάθε είδος επιχείρησης και επαγγελματία.",
    },
    who1: { en: "Shops & Retail Stores", gr: "Καταστήματα & Λιανική" },
    who2: { en: "Restaurants & Cafés", gr: "Εστιατόρια & Καφέ" },
    who3: { en: "Freelancers & Consultants", gr: "Ελεύθεροι Επαγγελματίες & Σύμβουλοι" },
    who4: { en: "Artisans & Handmade Creators", gr: "Χειροτέχνες & Δημιουργοί" },
    who5: { en: "Gyms & Studios", gr: "Γυμναστήρια & Studios" },
    who6: { en: "Tourism & Hotels", gr: "Τουρισμός & Ξενοδοχεία" },
    who7: { en: "Health & Beauty", gr: "Υγεία & Ομορφιά" },
    who8: { en: "Any Business Ready to Go Digital", gr: "Κάθε Επιχείρηση που Θέλει να Μπει Online" },

    // Personal section
    personalTitle: { en: "Always by your side", gr: "Πάντα δίπλα σας" },
    personalQuote: {
      en: "Technology doesn't have to be complicated. I'm by your side personally at every step. We can meet in person or via an online call to plan together the next step for your business.",
      gr: "Η τεχνολογία δεν χρειάζεται να είναι περίπλοκη. Είμαι δίπλα σας προσωπικά σε κάθε βήμα. Μπορούμε να συναντηθούμε δια ζώσης ή μέσω online κλήσης για να σχεδιάσουμε μαζί το επόμενο βήμα της επιχείρησής σας.",
    },

    // Audit section
    auditTitle: { en: "Already have a Website?", gr: "Έχετε ήδη Website;" },
    auditDesc: {
      en: "We can audit your existing site and suggest improvements — from performance and SEO to design and conversion optimization. Let's take it to the next level together.",
      gr: "Μπορούμε να κάνουμε audit στο υπάρχον site σας και να προτείνουμε βελτιώσεις — από performance και SEO μέχρι design και βελτιστοποίηση μετατροπών. Ας το πάμε μαζί στο επόμενο επίπεδο.",
    },
    auditCta: { en: "Request a Free Audit →", gr: "Ζητήστε Δωρεάν Audit →" },

    // CTA
    ctaTitle: { en: "Let's Build Something Together", gr: "Ας Χτίσουμε Κάτι Μαζί" },
    ctaDesc: {
      en: "No matter your industry or size — we'll find the right solution for your business. Let's sit down and plan your next move.",
      gr: "Ανεξάρτητα από τον κλάδο ή το μέγεθός σας — θα βρούμε τη σωστή λύση για την επιχείρησή σας. Ας καθίσουμε και ας σχεδιάσουμε το επόμενο βήμα σας.",
    },
    ctaInPerson: { en: "Book a meeting in Thessaloniki", gr: "Κλείστε ραντεβού στη Θεσσαλονίκη" },
    ctaOnline: { en: "Book an Online meeting", gr: "Κλείστε Online συνάντηση" },
  },

  // Portfolio page
  portfolio: {
    title: { en: "Our Portfolio", gr: "Το Portfolio μας" },
    subtitle: {
      en: "A selection of our recent work in full-stack development, custom business tools, and interactive web applications.",
      gr: "Μια επιλογή από τα πρόσφατα έργα μας σε full-stack development, custom επιχειρηματικά εργαλεία και διαδραστικές web εφαρμογές.",
    },
    viewProject: { en: "View Project →", gr: "Δείτε το Έργο →" },
    ctaTitle: { en: "Have a Project in Mind?", gr: "Έχετε κάποιο Project στο μυαλό;" },
    ctaDesc: {
      en: "We'd love to hear about it. Let's discuss how we can bring your idea to life.",
      gr: "Θα χαρούμε να το ακούσουμε. Ας συζητήσουμε πώς μπορούμε να υλοποιήσουμε την ιδέα σας.",
    },
    ctaButton: { en: "Start a Conversation →", gr: "Ξεκινήστε μια Συζήτηση →" },
  },

  // Projects data
  projects: {
    qrescueTitle: { en: "QRescue – Emergency QR System", gr: "QRescue – Σύστημα QR Έκτακτης Ανάγκης" },
    qrescueDesc: {
      en: "A React-based application that generates emergency QR stickers for helmets, allowing first responders to access vital health data instantly.",
      gr: "Μια εφαρμογή βασισμένη σε React που δημιουργεί QR αυτοκόλλητα έκτακτης ανάγκης για κράνη, επιτρέποντας στους πρώτους ανταποκριτές να έχουν άμεση πρόσβαση σε ζωτικά δεδομένα υγείας.",
    },
    madsTitle: { en: "Mads - Electric Scooters", gr: "Mads - Ηλεκτρικά Πατίνια" },
    madsDesc: {
      en: "A web application for buying electric scooters, featuring a user-friendly interface and a robust backend for managing orders and inventory.",
      gr: "Μια web εφαρμογή για αγορά ηλεκτρικών πατινιών, με φιλικό interface και ισχυρό backend για διαχείριση παραγγελιών και αποθεμάτων.",
    },
    orderTitle: { en: "Internal Web App for Order Management", gr: "Εσωτερική Web Εφαρμογή Διαχείρισης Παραγγελιών" },
    orderDesc: {
      en: "Developed a custom web-based platform in React + Express for handling internal order requests with real-time tracking and status updates.",
      gr: "Ανάπτυξη custom web πλατφόρμας σε React + Express για διαχείριση εσωτερικών παραγγελιών με real-time tracking και ενημερώσεις κατάστασης.",
    },
    recreatingTitle: { en: "Recreating the Past", gr: "Recreating the Past" },
    recreatingDesc: {
      en: "A public history academic website publishing documented historical texts, news, and resources on Greek and military history, with a focus on Thessaloniki.",
      gr: "Ιστότοπος δημόσιας ιστορίας που δημοσιεύει τεκμηριωμένα ιστορικά κείμενα, ειδήσεις και πόρους για την ελληνική και στρατιωτική ιστορία, με έμφαση στη Θεσσαλονίκη.",
    },
    greekTitle: { en: "GreekHumans", gr: "GreekHumans" },
    greekDesc: {
      en: "Maintenance and development of a web application for the GreekHumans community, focusing on user engagement and content management.",
      gr: "Συντήρηση και ανάπτυξη web εφαρμογής για την κοινότητα GreekHumans, με εστίαση στο user engagement και τη διαχείριση περιεχομένου.",
    },
    nutritionTitle: { en: "NutritionGoals", gr: "NutritionGoals" },
    nutritionDesc: {
      en: "A nutrition and dietetics platform helping users set and track their dietary goals, with personalized meal plans and professional guidance.",
      gr: "Μια πλατφόρμα διατροφής που βοηθά τους χρήστες να θέσουν και να παρακολουθούν τους διατροφικούς τους στόχους, με εξατομικευμένα πλάνα γευμάτων και επαγγελματική καθοδήγηση.",
    },
    tennisTitle: { en: "Tennisstars Thessaloniki", gr: "Tennisstars Θεσσαλονίκη" },
    tennisDesc: {
      en: "A modern website for a tennis club in Thessaloniki, showcasing programs for all ages, facilities, and an easy contact system for booking training sessions.",
      gr: "Ένας σύγχρονος ιστότοπος για έναν σύλλογο τένις στη Θεσσαλονίκη, που παρουσιάζει προγράμματα για όλες τις ηλικίες, εγκαταστάσεις και εύκολο σύστημα επικοινωνίας για κράτηση προπονήσεων.",
    },
  },

  // Contact page
  contact: {
    title: { en: "Contact Us", gr: "Επικοινωνία" },
    subtitle: {
      en: "Let's connect and discuss how we can help your business succeed.",
      gr: "Ας συνδεθούμε και ας συζητήσουμε πώς μπορούμε να βοηθήσουμε την επιχείρησή σας να πετύχει.",
    },
    nameLabel: { en: "Your Name", gr: "Το Όνομά σας" },
    emailLabel: { en: "Your Email", gr: "Το Email σας" },
    topicWebsite: { en: "I need a Website", gr: "Θέλω Website" },
    topicEshop: { en: "I need an E-shop", gr: "Θέλω E-shop" },
    topicMarketing: { en: "Digital Marketing", gr: "Digital Marketing" },
    topicAudit: { en: "Website Audit / Upgrade", gr: "Audit / Αναβάθμιση Website" },
    topicOther: { en: "Other", gr: "Άλλο" },
    messageLabel: { en: "Your message...", gr: "Το μήνυμά σας..." },
    sendButton: { en: "Send Message", gr: "Αποστολή Μηνύματος" },
    successMsg: { en: "Thank you! Your message has been sent.", gr: "Ευχαριστούμε! Το μήνυμά σας στάλθηκε." },
    altEmail: { en: "You can also email us directly:", gr: "Μπορείτε επίσης να μας στείλετε email:" },
    topicHandmade: { en: "Handmade Creators Package", gr: "Πακέτο Χειροτεχνών" },
    meetingTitle: { en: "Prefer a personal meeting?", gr: "Προτιμάτε προσωπική συνάντηση;" },
    meetingDesc: {
      en: "We can meet in person or have an online call — whatever works best for you.",
      gr: "Μπορούμε να συναντηθούμε από κοντά ή να κάνουμε online κλήση — ό,τι σας βολεύει.",
    },
    ctaInPerson: { en: "Book an In-Person Meeting", gr: "Κλείστε δια ζώσης ραντεβού" },
    ctaOnline: { en: "Book an Online Meeting", gr: "Κλείστε Online Meeting" },
  },

  // Privacy
  privacy: {
    title: { en: "Privacy Policy", gr: "Πολιτική Απορρήτου" },
    lastUpdated: { en: "Last updated: March 2025", gr: "Τελευταία ενημέρωση: Μάρτιος 2025" },
    intro: {
      en: "This website, myapple.gr, respects your privacy and is committed to protecting any personal information you provide.",
      gr: "Αυτός ο ιστότοπος, myapple.gr, σέβεται το απόρρητό σας και δεσμεύεται να προστατεύει κάθε προσωπική πληροφορία που παρέχετε.",
    },
    cookiesTitle: { en: "2. Cookies", gr: "2. Cookies" },
    cookiesText: {
      en: "We use cookies to enhance your experience and to analyze website traffic via Google Analytics. These cookies are only activated after you give consent.",
      gr: "Χρησιμοποιούμε cookies για τη βελτίωση της εμπειρίας σας και την ανάλυση της επισκεψιμότητας μέσω Google Analytics. Αυτά τα cookies ενεργοποιούνται μόνο μετά τη συγκατάθεσή σας.",
    },
    analyticsTitle: { en: "3. Analytics", gr: "3. Analytics" },
    analyticsText: {
      en: "Google Analytics may collect anonymized data such as your device type, location (approximate), and pages visited.",
      gr: "Το Google Analytics ενδέχεται να συλλέγει ανωνυμοποιημένα δεδομένα όπως τον τύπο συσκευής, τοποθεσία (κατά προσέγγιση) και σελίδες που επισκεφθήκατε.",
    },
    dataTitle: { en: "4. Data Collection", gr: "4. Συλλογή Δεδομένων" },
    dataText: {
      en: "No personally identifiable information is collected unless explicitly submitted through contact forms.",
      gr: "Δεν συλλέγονται προσωπικά αναγνωρίσιμα στοιχεία εκτός αν υποβληθούν ρητά μέσω φορμών επικοινωνίας.",
    },
    contactTitle: { en: "5. Contact", gr: "5. Επικοινωνία" },
    contactText: {
      en: "For any questions about this policy, please contact",
      gr: "Για οποιαδήποτε ερώτηση σχετικά με αυτή την πολιτική, επικοινωνήστε στο",
    },
  },

  // Handmade Creators page
  handmade: {
    badge: { en: "For Handmade Creators", gr: "Για Χειροτέχνες & Δημιουργούς" },
    heroTitle: {
      en: "A Digital Home for the Creators of the By Hand Festival",
      gr: "Ψηφιακή Στέγη για τους Δημιουργούς του By Hand Festival",
    },
    heroSubtitle: {
      en: "Your creations deserve to be seen beyond the exhibition booth. We build your online presence — personally, step by step, together.",
      gr: "Οι δημιουργίες σας αξίζουν να φαίνονται πέρα από τον πάγκο της έκθεσης. Χτίζουμε τη διαδικτυακή σας παρουσία — προσωπικά, βήμα-βήμα, μαζί.",
    },
    heroCta: { en: "See the Plans", gr: "Δείτε τα Πακέτα" },
    heroCtaContact: { en: "Let's Talk", gr: "Ας Μιλήσουμε" },

    // Personal support section
    personalTitle: { en: "Personal Support", gr: "Προσωπική Υποστήριξη" },
    personalQuote: {
      en: "I want you to know that in this journey I'll be right by your side, personally. We can meet in person or have an online call, so we find exactly what suits you.",
      gr: "Θέλω να ξέρετε ότι σε αυτό το εγχείρημα θα είμαι δίπλα σας προσωπικά. Μπορούμε να συναντηθούμε από κοντά ή να κάνουμε μια online κλήση, ώστε να βρούμε ακριβώς τι σας ταιριάζει.",
    },
    personalDesc: {
      en: "We're not just a platform — we're your partner. From picking your domain name to launching your first campaign, every step is guided, human, and tailored to you.",
      gr: "Δεν είμαστε απλά μια πλατφόρμα — είμαστε ο συνεργάτης σας. Από την επιλογή του domain σας μέχρι την πρώτη καμπάνια, κάθε βήμα γίνεται με καθοδήγηση, ανθρώπινα και εξατομικευμένα.",
    },
    founderName: { en: "Alex, Founder of MyApple", gr: "Αλέξανδρος, Ιδρυτής MyApple" },

    // Pricing section
    pricingTitle: { en: "Choose Your Plan", gr: "Επιλέξτε το Πακέτο σας" },
    pricingSubtitle: {
      en: "Three levels of support, designed for creators at every stage of their digital journey.",
      gr: "Τρία επίπεδα υποστήριξης, σχεδιασμένα για δημιουργούς σε κάθε στάδιο της ψηφιακής τους πορείας.",
    },

    // Bronze
    bronzeName: { en: "Bronze", gr: "Bronze" },
    bronzeTitle: { en: "Your Digital Showcase", gr: "Η Ψηφιακή σας Βιτρίνα" },
    bronzeDesc: {
      en: "A beautiful, simple website to present your work and let customers find you online.",
      gr: "Ένα όμορφο, απλό website για να παρουσιάσετε τα έργα σας και να σας βρίσκουν οι πελάτες online.",
    },
    bronzeCta: { en: "Let's start simple", gr: "Ας ξεκινήσουμε απλά" },

    // Silver
    silverName: { en: "Silver", gr: "Silver" },
    silverTitle: { en: "The Handmade E-shop", gr: "Το Χειροποίητο E-shop" },
    silverDesc: {
      en: "Your own online store with inventory management, courier integration, and everything you need to sell your creations.",
      gr: "Το δικό σας online κατάστημα με διαχείριση αποθέματος, σύνδεση courier και ό,τι χρειάζεστε για να πουλάτε τις δημιουργίες σας.",
    },
    silverCta: { en: "I want an E-shop", gr: "Θέλω E-shop" },

    // Gold
    goldName: { en: "Gold", gr: "Gold" },
    goldTitle: { en: "The Complete Exhibition", gr: "Η Ολοκληρωμένη Έκθεση" },
    goldDesc: {
      en: "Full digital presence with e-shop, targeted advertising for new customers, social media management, and ongoing support.",
      gr: "Πλήρης ψηφιακή παρουσία με e-shop, στοχευμένη διαφήμιση για νέους πελάτες, διαχείριση social media και συνεχή υποστήριξη.",
    },
    goldCta: { en: "I want the full package", gr: "Θέλω το πλήρες πακέτο" },

    // Comparison table features
    featureWebsite: { en: "Professional Website", gr: "Επαγγελματικό Website" },
    featureHosting: { en: "Hosting & Professional Email", gr: "Φιλοξενία & Επαγγελματικό Email" },
    featureDomain: { en: "Custom Domain (yourname.gr)", gr: "Custom Domain (ονομασας.gr)" },
    featureResponsive: { en: "Mobile-Friendly Design", gr: "Σχεδιασμός για Κινητά" },
    featureSeo: { en: "Basic SEO Setup", gr: "Βασική Ρύθμιση SEO" },
    featureEshop: { en: "Full Online Store (inventory & courier)", gr: "Πλήρες Online Κατάστημα (απόθεμα & Courier)" },
    featurePayments: { en: "Online Payments", gr: "Online Πληρωμές" },
    featureAds: { en: "Targeted Ads for New Customers", gr: "Στοχευμένη Διαφήμιση για νέους πελάτες" },
    featureSocial: { en: "Social Media Management", gr: "Διαχείριση Social Media" },
    featureSupport: { en: "Ongoing Monthly Support", gr: "Μηνιαία Υποστήριξη" },
    featureAnalytics: { en: "Analytics & Reports", gr: "Analytics & Αναφορές" },
    featurePersonal: { en: "Personal Consultation", gr: "Προσωπική Συμβουλευτική" },

    // Table header
    tableFeature: { en: "What you get", gr: "Τι περιλαμβάνει" },

    // CTA section
    ctaTitle: { en: "Let's Build Your Digital Home", gr: "Ας Χτίσουμε τη Ψηφιακή σας Στέγη" },
    ctaDesc: {
      en: "Whether you want to start with a simple showcase or go all-in with an online store and ads — I'm here to help you every step of the way.",
      gr: "Είτε θέλετε να ξεκινήσετε με μια απλή βιτρίνα είτε να πάτε all-in με e-shop και διαφημίσεις — είμαι εδώ να σας βοηθήσω σε κάθε βήμα.",
    },
    ctaInPerson: { en: "Book an In-Person Meeting", gr: "Κλείστε δια ζώσης ραντεβού" },
    ctaOnline: { en: "Book an Online Meeting", gr: "Κλείστε Online Meeting" },
  },

  // Cookie consent
  cookie: {
    text: {
      en: "This website uses cookies to improve experience and track usage.",
      gr: "Αυτός ο ιστότοπος χρησιμοποιεί cookies για τη βελτίωση της εμπειρίας και την παρακολούθηση χρήσης.",
    },
    learnMore: { en: "Learn more", gr: "Μάθετε περισσότερα" },
    accept: { en: "Accept", gr: "Αποδοχή" },
  },

  // Footer
  footer: {
    rights: { en: "All rights reserved.", gr: "Με επιφύλαξη παντός δικαιώματος." },
  },

  // Scroll to top
  scrollTop: { en: "Back to top", gr: "Πίσω στην κορυφή" },
};

export const t = (key, lang) => {
  const keys = key.split(".");
  let value = translations;
  for (const k of keys) {
    value = value?.[k];
  }
  if (value && typeof value === "object" && (value.en || value.gr)) {
    return value[lang] || value.en;
  }
  return value || key;
};

export default translations;
